// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import React from "react";
import { Card } from "antd";

interface BodyProps {
  children: object;
  className?: string | null;
}

const PageBody: React.FunctionComponent<BodyProps> = (props: BodyProps) => {
  const { children, className } = props;

  return (
    <>
      <div className={`content-body ${className ? className : ""}`}>
        <Card bordered={false}>{children}</Card>
      </div>
    </>
  );
};

export default PageBody;
